import React from 'react';
import classNames from 'classnames';

const ProgressBar = ({ question }) => {

  const items = () => {
    const spans = [];
    for (let i = 0; i < 10; i++) {
      spans.push(<span key={i} className={classNames({
        outer: true,
        done: i < question - 1,
        active: i === question - 1,
      })}><span></span></span>);
    }
    return spans;
  };

  return (
    <div className={`progress ${question === 2? 'question2-progressbar' : ''}`}>
      {items()}
    </div>
  );
};

export default ProgressBar;
